import { render, staticRenderFns } from "./ContainersManagerForm.vue?vue&type=template&id=20b43084&"
import script from "./ContainersManagerForm.vue?vue&type=script&lang=ts&"
export * from "./ContainersManagerForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports